import React, { useState } from 'react';
import { ArrowRightIcon, CheckIcon, CircleAlertIcon, SparklesIcon } from 'lucide-react';
import { readiness } from '../../data/loisirs';
export function ReadinessCard() {
  const [fixed, setFixed] = useState(false);
  return <section aria-labelledby="ready-title" className="rounded-3xl border border-slate-200 bg-white p-6 sm:p-7" data-id="element-1534" data-mp="14quiixy7pzsu">
      <div className="flex items-start gap-3" data-id="element-1535" data-mp="1enqtdabl2y0k">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-ville-indigo-soft text-ville-indigo" aria-hidden="true" data-id="element-1536" data-mp="1emfqdcpypuai">
          <SparklesIcon className="h-5 w-5" data-id="element-1537" data-mp="19mtcr2682c16" />
        </span>
        <div className="min-w-0" data-id="element-1538" data-mp="1ner3xxzz9n92">
          <h2 id="ready-title" className="text-lg font-extrabold tracking-tight text-ville-navy" data-id="element-1539" data-mp="1ni59tg7uoel9">
            Ready to register
          </h2>
          <p className="mt-1 text-sm text-slate-600" data-id="element-1540" data-mp="1xdf9vyeoubwe">
            {readiness.activity} · opens {readiness.opensOn}
          </p>
        </div>
      </div>

      {fixed ? <p className="mt-5 flex items-center gap-2 rounded-2xl bg-ville-indigo-soft px-4 py-3 text-sm font-semibold text-ville-indigo" data-id="element-1541" data-mp="1wm90oos89o36">
          <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-1542" data-mp="21met476bnemb" />
          Everything is ready for registration {readiness.opensOn}.
        </p> : <div className="mt-5 rounded-2xl border border-slate-200 bg-slate-50 p-5" data-id="element-1543" data-mp="26mt1jqbu4qkv">
          <p className="flex items-start gap-2 text-[15px] font-bold text-ville-navy" data-id="element-1544" data-mp="2ajxifnr00f40">
            <CircleAlertIcon className="mt-0.5 h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-1545" data-mp="2fkv101fx7b61" />
            {readiness.blocking.label}
          </p>
          <p className="mt-1.5 pl-7 text-sm text-slate-600" data-id="element-1546" data-mp="2paendh2udn5n">{readiness.blocking.detail}</p>
          <button type="button" onClick={() => setFixed(true)} className="ml-7 mt-4 inline-flex items-center gap-2 rounded-full bg-ville-navy px-5 py-2.5 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1547" data-mp="2uaj1x1k6w7t8">
            Fix it now
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1548" data-mp="z7w3zk1cjfhi" />
          </button>
        </div>}

      <ul className="mt-5 flex flex-wrap gap-x-5 gap-y-2" data-id="element-1549" data-mp="1cz17wybqytxn">
        {readiness.checks.map(check => {
        const ok = fixed || check.ok;
        return <li key={check.id} className="flex items-center gap-2 text-sm" data-id="element-1550" data-mp="1mvxjxe0uty6y">
              <span className={`grid h-5 w-5 place-items-center rounded-full ${ok ? 'bg-ville-indigo-soft text-ville-indigo' : 'bg-slate-200 text-slate-500'}`} aria-hidden="true" data-id="element-1551" data-mp="1my9wtcrr9id5">
                {ok ? <CheckIcon className="h-3 w-3" data-id="element-1552" data-mp="1qytvwlvw2w1x" /> : <CircleAlertIcon className="h-3 w-3" data-id="element-1553" data-mp="1j4aelpuf1ot" />}
              </span>
              <span className={ok ? 'text-slate-600' : 'font-semibold text-ville-navy'} data-id="element-1554" data-mp="1l6w4tjyq8nq">{check.label}</span>
            </li>;
      })}
      </ul>
    </section>;
}